module.exports = __webpack_public_path__ + "static/media/processing.5854f5a6.svg";